module.exports = __webpack_public_path__ + "static/img/logo3.a0d7f572.png";